<script setup>
import { Icon, Button } from '@components'

const emit = defineEmits(['click'])

const props = defineProps({
    text: {
        type: String,
        default: 'Back'
    }
})
</script>
<template>
    <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] justify-between" @click="emit('click')">
        <div class="w-[70%]">{{ props.text }}</div>
        <template #before>
            <Icon name="arrowNarrowLeft" size="20px"></Icon>
        </template>
    </Button>
</template>


<style>

</style>